/*
########   ########      ###     ########   ##    ##   
##     ##  ##           ## ##    ##     ##   ##  ##    
##     ##  ##          ##   ##   ##     ##    ####     
########   ######     ##     ##  ##     ##     ##      
##   ##    ##         #########  ##     ##     ##      
##    ##   ##         ##     ##  ##     ##     ##      
##     ##  ########   ##     ##  ########      ##      
*/
jQuery(document).ready(function($) {

	$('[data-link]').click(function() {
		if( $(this).attr('target') ){
			window.open( $(this).data("link") , $(this).attr('target'));
		}else{
			window.location.href = $(this).data('link');
		}
	}).find('a').click(function(e) {
		e.stopPropagation();
	});


	/**
	 * Test si les Media Queries sont supportées
	 * Ajoute la classe 'mq' au tag HTML si c'est le cas
	 */
	if ( Modernizr.mq('only all') ) {
			jQuery('html').addClass('mq');
	} else {
			jQuery('html').addClass('no-mq');
	}

	/**
	 * MatchHeight [GRID]
	 */
	$('.harmonize').imagesLoaded( function() {
		$(".harmonize").matchHeight();
	});

	// Fitvids
	$('.fitvids').fitVids();

	/*
	 * MENU
	 */

	$('.nav-toggle').click(function(e){
		e.preventDefault();
		$('body').toggleClass('nav-open');
	});

	$('.nav-close').click(function(e){
		e.preventDefault();
		$('body').removeClass('nav-open');
	});

	$('.nav-toggle-fixed').click(function(e){
		e.preventDefault();
		$('.header').toggleClass('stuck-active');
	});

	/*
	 * HOME
	 */

	if( $('.slick-home-slider').length > 0 ){

		var slickHome = $('.slick-home-slider').on('init', function(event, slick){
		}).slick({
			arrows:    false,
			prevArrow: $('.slick-home-nav--prev'),
			nextArrow: $('.slick-home-nav--next'),
			swipe:     false,
			speed:     500,
			lazyLoad: 'progressive'
		}).on('afterChange', function(event, slick, currentSlide){
			event.stopPropagation();
			$('.slick-current', this).addClass('slick-slide--active');
		});

		$('.slick-home-nav--next').click(function(e){
			e.preventDefault();		
			$('.slick-home-slider').css('background-color','transparent');
			setTimeout(function() {
			    slickHome.slick('slickNext');
			}, 400);
			$('.slick-current', slickHome).removeClass('slick-slide--active');
		});

		$('.slick-home-nav--prev').click(function(e){
			e.preventDefault();		
			$('.slick-home-slider').css('background-color','transparent');
			setTimeout(function() {
			    slickHome.slick('slickPrev');
			}, 400);
			$('.slick-current', slickHome).removeClass('slick-slide--active');
		});

	}

	/*
	##     ##     ###     ########   
	###   ###    ## ##    ##     ##  
	#### ####   ##   ##   ##     ##  
	## ### ##  ##     ##  ########   
	##     ##  #########  ##         
	##     ##  ##     ##  ##         
	##     ##  ##     ##  ##         
	*/

	if( $('#map').length > 0 ){

		var stylez = [{"featureType":"administrative","elementType":"all","stylers":[{"saturation":"-100"}]},{"featureType":"administrative.province","elementType":"all","stylers":[{"visibility":"off"}]},{"featureType":"landscape","elementType":"all","stylers":[{"saturation":-100},{"lightness":65},{"visibility":"on"}]},{"featureType":"poi","elementType":"all","stylers":[{"saturation":-100},{"lightness":"50"},{"visibility":"simplified"}]},{"featureType":"road","elementType":"all","stylers":[{"saturation":"-100"}]},{"featureType":"road.highway","elementType":"all","stylers":[{"visibility":"simplified"}]},{"featureType":"road.arterial","elementType":"all","stylers":[{"lightness":"30"}]},{"featureType":"road.local","elementType":"all","stylers":[{"lightness":"40"}]},{"featureType":"transit","elementType":"all","stylers":[{"saturation":-100},{"visibility":"simplified"}]},{"featureType":"water","elementType":"geometry","stylers":[{"hue":"#ffff00"},{"lightness":-25},{"saturation":-97}]},{"featureType":"water","elementType":"labels","stylers":[{"lightness":-25},{"saturation":-100}]}];
		var defaultLat  = $('#map').attr('data-lat');
		var defaultLng  = $('#map').attr('data-lng');
		var defaultZoom = 16;

		const simpleMap = new GMaps( {
			div:              '#map',
			lat:              defaultLat,
			lng:              defaultLng,
			zoom:             defaultZoom,
			scrollwheel:      false,
			disableDefaultUI: false,
			options: {
				'styles':    stylez
			}
		});

		// var image = new google.maps.MarkerImage(icon, null, null, null, new google.maps.Size(26,39));

		var element = simpleMap.addMarker({
			lat:       defaultLat,
			lng:       defaultLng,
			// icon:      image
		});

	}

	/*
	####   ######     #######   ########    #######   ########   ########   
	 ##   ##    ##   ##     ##     ##      ##     ##  ##     ##  ##         
	 ##   ##         ##     ##     ##      ##     ##  ##     ##  ##         
	 ##    ######    ##     ##     ##      ##     ##  ########   ######     
	 ##         ##   ##     ##     ##      ##     ##  ##         ##         
	 ##   ##    ##   ##     ##     ##      ##     ##  ##         ##         
	####   ######     #######      ##       #######   ##         ########   
	*/

    function loadVisible($els, trigger) {
        $els.filter(function () {
            var rect = this.getBoundingClientRect();
            return rect.top >= 0 && rect.top <= window.innerHeight;
        }).trigger(trigger);
    }

	if( $('.grid-isotope').length > 0 ){

		var $win = $(window),
	        $grid = $('.grid-isotope'),
	        $imgs = $(".grid-item--img img", $grid);

		$grid.isotope({
			itemSelector: '.grid-item',
			layoutMode: 'fitRows'
		});
	    
		$imgs.unveil(200, function() {
			$(this).load(function() {
				$(this).addClass('is-load');
				$grid.isotope('layout');
			});
		});

	}


	// Filtre des appartements par numéro d'entrée
	var filters = document.querySelectorAll('.filter-entry li');
	var flats = document.querySelectorAll('.thumb--flat');
	filters.forEach( (filter) => {
		filter.addEventListener('click', (e) => {
			if( filter.classList.contains('current') ) {
				filters.forEach((filter) => {
					filter.classList.remove('current');
				});
				flats.forEach( (flat) => {
					flat.classList.remove('hidden');
				});
			}else{
				filters.forEach( (filter) => {
					filter.classList.remove('current');
				});
				filter.classList.add('current');
				flats.forEach( (flat) => {
					if( flat.dataset.entry === filter.dataset.filter ){
						flat.classList.remove('hidden');
					}else{
						flat.classList.add('hidden');
					}
				});
			}
		});
	});

});
